<template>
  <div>
    <div ref="hint" class="hint" @click="$emit('click')">
      <div class="hint-icon">i</div>

      <div class="hint-text">
        {{ $t("socialMedia.helpUnderstand") }}
      </div>
    </div>

    <div class="hint-content" ref="hintContent">
      <div class="hint-content-header">
        {{ $t("socialMedia.aboutBlockUnsupported") }}
      </div>

      <div class="divider" />

      <div>
        {{ $t("socialMedia.description1") }}
        <div class="divider" />
        {{ $t("socialMedia.description2") }}
        <div class="divider" />
        {{ $t("socialMedia.description3") }}
      </div>
    </div>
  </div>
</template>

<script>
  import tippy from 'tippy.js'

  export default {
    mounted() {
      this.initHint()
    },

    methods: {
      initHint() {
        tippy(this.$refs.hint,  {
          allowHTML: true,
          content: this.$refs.hintContent,
          trigger: 'click',
          hideOnClick: true,
          interactive: true,
          theme: 'custom-light',
          placement: 'bottom',
          animation: 'shift-away',
          arrow: true,
          inertia: true,
          duration: [400, 300]
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .hint {
    display: flex;
    align-items: center;
    justify-content: center;

    color: map.get($colors, primary);

    font-size: 13px;
    cursor: pointer;

    &-icon {
      display: flex;
      justify-content: center;

      width: 16px;
      height: 16px;
      font-weight: bold;
      border: 1px solid;
      border-radius: 50%;
      margin-right: 5px;
      padding-top: 1px;
    }

    &-text {
      padding: 2px 0 0 0;
    }
  }

  .hint-content {
    padding: 10px;
    text-align: left;

    &-header {
      font-size: 18px;
    }
  }
</style>